export default "__VITE_ASSET__Om6k_T0y__"